<template>
  <div :id="inputDivId" class="multi-tile comp-start">
    <div class="select-card-ques">
      {{ info.message }}
    </div>
    <div
      v-for="(item, itemIndex) in list"
      :key="itemIndex"
      class="col-md-4 col-xs-12 select-card"
      :class="[
        item.isSelected ? 'selected-card' : '',
        heightClass,
        item.isSelected ? selectedClass : '',
      ]"
      @click="onSelectItem(itemIndex)"
    >
      <span v-if="item.isSelected ? true : null" class="show-icon">
        <img src="@/assets/img/tick-icon.png" class="tick-icon" />
      </span>
      <div class="tile-data">
        {{ item.shortName }}
        <span
          v-show="item.fullName !== ''"
          class="more_info"
          @click.stop="toggleTooltip(itemIndex)"
        >
          ...
          <span v-show="item.tooltip" class="toolTip">
            {{ item.fullName }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import _ from "underscore";
import Utils from "@/utils/utilities";
import EventEmitter from "@/utils/eventEmitter";

@Component({})
export default class MultiSelect extends Vue {
  public list: any = [];
  public selectedList: any = [];
  public heightClass: any;
  public selectedClass: any;
  public inputDivId = "";

  @Prop()
  public info!: any;

  async mounted() {
    let strLength: any = 10;
    this.inputDivId = "multi-tile-" + this.info.id;
    if (this.info && this.info.type_values) {
      let listKeyInJSON = await Utils.getQuestionsMatchedListKey(this.info.id);

      if (
        this.info.type_values[listKeyInJSON] &&
        this.info.type_values[listKeyInJSON].length > 0
      ) {
        this.list = this.info.type_values[listKeyInJSON];
        this.list = _.sortBy(this.list, "order");
      }

      if (this.info.values && this.info.values.length > 0) {
        for (let i = 0; i < this.info.values.length; i++) {
          const iRecIndex = this.list.findIndex(
            (r: any) => r.id === this.info.values[i],
          );
          if (iRecIndex >= 0) {
            this.list[iRecIndex].isSelected = true;
          }
        }
      }

      for (let i = 0; i < this.list.length; i++) {
        if (strLength <= this.list[i].name.length)
          strLength = this.list[i].name.length;

        this.list[i].fullName = "";
        this.list[i].shortName = this.list[i].name;
        this.list[i].tooltip = false;
        if (this.list[i].name.length > 66) {
          let shortString = this.list[i].name.slice(0, 41);
          this.list[i].fullName = this.list[i].name;
          this.list[i].shortName = shortString;
        }
      }

      this.changeHeight(strLength);
    }
    const context = this;
    setTimeout(function () {
      context.getInputPosition();
    }, 1000);
  }

  changeHeight(len: number) {
    if (len <= 10) {
      this.heightClass = "custom-10";
      this.selectedClass = "selected-10";
    } else if (len <= 20 && len > 10) {
      this.heightClass = "custom-20";
      this.selectedClass = "selected-20";
    } else if (len <= 30 && len > 20) {
      this.heightClass = "custom-30";
      this.selectedClass = "selected-30";
    }
    // else if (len<=40 &&len>30){
    //   this.heightClass="custom-40";
    //    this.selectedClass="selected-40";
    // }
    else {
      this.heightClass = "custom-40";
      this.selectedClass = "selected-40";
    }
  }

  onSelectItem(itemIndex: number) {
    if (itemIndex >= 0) {
      let dupList: any = [].concat(this.list);
      dupList[itemIndex].isSelected = dupList[itemIndex].isSelected
        ? false
        : true;
      this.list = [].concat(dupList);
    }
  }

  toggleTooltip(itemIndex: number) {
    if (itemIndex >= 0) {
      let dupList: any = [].concat(this.list);
      dupList[itemIndex].tooltip = !dupList[itemIndex].tooltip;
      this.list = [].concat(dupList);
    }
  }
  getInputPosition() {
    const inputElem: any = document.getElementById("" + this.inputDivId);
    if (inputElem && this.info.guidance && this.info.guidance !== null) {
      const inputPosition = inputElem.getBoundingClientRect();
      EventEmitter.emit("APP_INPUT_POSITION", inputPosition.top);
    }
  }
  beforeUnmount() {
    this.list = [];
    this.selectedList = [];
  }
}
</script>
<style lang="scss" scoped>
.multi-tile {
  display: table;
}
.select-card-ques {
  color: #231f20;
  font-size: 26px;
  margin-bottom: 39px;
}
.select-card {
  border: 3px solid #ffffff;
  box-sizing: content-box;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  padding: 15px 10px 10px;
  text-align: center;
  background: #ffffff;
  margin-right: 15px;
  margin-left: 15px;
  max-width: 24%;
  color: #0345bd;
  font-size: 18px;
  float: left;
  /* display: inline-block; */
  margin-bottom: 20px;
  margin-top: 20px;
  cursor: pointer;
  position: relative;
  word-break: break-word;
  align-items: center;
  display: flex;
}

.tile-data {
  width: 100%;
  text-align: center;
}

.select-card .show-icon {
  display: none;
}
.custom-10 {
  height: 70px;
}
.custom-20 {
  height: 90px;
}
.custom-30 {
  height: 87px;
}
.custom-40 {
  height: 158px;
}
.selected-card {
  background: #0345bd;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  color: white;
  padding: 25px 20.5px 25px;
  max-width: 24%;
  margin-right: 7.5px;
  margin-left: 7.5px;
  margin-top: 11px;
  margin-bottom: 10px;
  text-align: center;
  border: none !important;
}
.selected-10 {
  height: 70px;
}
.selected-20 {
  height: 90px;
}
.selected-30 {
  height: 87px;
  margin-top: 13px;
  margin-bottom: 12px;
  padding: 26px 20.5px 20px;
}
.selected-40 {
  height: 158px;
}
.selected-card .show-icon {
  display: block;
  position: absolute;
  right: 2%;
  top: 0%;
}
.tick-icon {
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
  padding: 3px;
  background: #ffffff;
}

.btn {
  width: 100%;
  border: none;
  background-color: inherit;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}
</style>
